/*
  This hook is used to fetch user's payment cards information
*/

import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getInstorePaymentCards } from 'core/actions/member';
import { selectUserIsAuthenticated } from 'core/selectors/user';
import { CARDS_LIMIT } from 'core/modules/Instore2/utils/constants';
import {
  selectPaymentCards, selectPaymentCardsIsLoaded, selectPaymentCardsIsLoading, selectDynamicallyDeletedCards,
} from '../selectors';

export const useGetPaymentCards = () => {
  const dispatch = useDispatch();
  const cards = useSelector(selectPaymentCards);
  const isLoaded = useSelector(selectPaymentCardsIsLoaded);
  const isLoading = useSelector(selectPaymentCardsIsLoading);
  const isUserAuthenticated = useSelector(selectUserIsAuthenticated);

  useEffect(() => {
    if (!isLoaded && !isLoading && isUserAuthenticated) {
      dispatch(getInstorePaymentCards());
    }
  }, [isLoaded, isLoading]);

  const dynamicallyDeletedCards = useSelector(selectDynamicallyDeletedCards);
  const checkCardIsDynamicallyDeleted = (cardId) => dynamicallyDeletedCards.includes(cardId);
  const availableCards = cards.filter(({ cardId }) => !checkCardIsDynamicallyDeleted(cardId));
  const isCardLimitReached = availableCards.length >= CARDS_LIMIT;

  return {
    cards, // All cards, including dynamically removed ones which are needed to show "card *** was removed" messages
    isLoaded,
    isLoading,
    availableCards, // Available user cards, excluding dynamically removed cards
    isCardLimitReached,
    checkCardIsDynamicallyDeleted,
  };
};
